import { FilterGroup } from '../Tools/FilterGroup';
import { NameFilter } from '../Filters/NameFilter';
import { SvgFilter } from '../Filters/SvgFilter';
import { CoatingTypeFilter } from '../Filters/CoatingTypeFilter';
import { ColorFilter } from '../Filters/ColorFilter';
import { ShowPriorityFilter } from '../Filters/ShowPriorityFilter';
import { ShowUnavailableFilter } from '../Filters/ShowUnavailableFilter';
import { ShowNewObjectsFilter } from '../Filters/ShowNewObjectsFilter';
import { HangFilter } from '../Filters/HangFilter';
import { UniversesFilter } from '../Filters/UniversesFilter';
import { FiltersWidget } from '../FiltersWidget';
import { IFilter } from '../Tools/IFilter';
import { FiltersController } from '../Tools/FiltersController';

export class CoatingsFilterWiget extends FilterGroup {
    constructor(container: string) {
        super();
        this.id = 'coatings';
        this.name = 'Matériaux';
        this.icon = 'fas fa-lg fa-paint-roller';
        this.resource = 'coatings';
        this.showPriority = 'REFERENCED';
        this.hang = 'ALL';
        this.universes = {
            indoor: FiltersWidget.deliverable && FiltersWidget.deliverable.room_type !== 59 ? true : false,
            bathroom: false,
            outdoor: FiltersWidget.deliverable && FiltersWidget.deliverable.room_type === 59 ? true : false,
            junior: false,
            B2B: false
        };
        this.filtersFunction = 'updateFilters';
        this.container = container;
        this.filters = [
            new NameFilter(this),
            new CoatingTypeFilter(this),
            new SvgFilter(this),
            new ColorFilter(this),
            new ShowPriorityFilter(this, false),
            new ShowUnavailableFilter(this, true, false, 2),
            new ShowNewObjectsFilter(this, false, true, 2),
            new HangFilter(this),
            new UniversesFilter(this)
        ];
        this.controller = new FiltersController();

        this.filtersHtml = () => {
            let AssetsFilterWidgetHtml = '';
            this.filters.forEach((filter: IFilter) => {
                AssetsFilterWidgetHtml += `${filter.html()}`;
            });
            return AssetsFilterWidgetHtml;
        };
    }

    generateSortString() {
        let sort: any[] = [];
        let sortString = '';

        if (FilterGroup.filters.useColorSearch) {
            return(sortString);
        } 

        if (!FilterGroup.smartSearch()) {
            if (!FilterGroup.filters.universes!.indoor && !FilterGroup.filters.universes!.bathroom && !FilterGroup.filters.universes!.outdoor && !FilterGroup.filters.universes!.junior && FilterGroup.filters.showPriority === 'PLACEHOLDERS') {
                sort.push('-universes.indoor');
                sort.push('-universes.bathroom');
                sort.push('-universes.outdoor');
                sort.push('-universes.junior');
            }
        }

        if (sort.length > 0) {
            sortString += '&sort=' + sort.join(',');
        }

        return(sortString);
    }

    generateStringFilter() {
        var i: number;
        let stringFilters = '&q.pipeline.modelState.eq=validated&q.pipeline.unrealState.eq=ready&q.hang.cabinet.eq=false&q.hang.worktop.eq=false&q.hang.credence.eq=false'
        let filters = FilterGroup.filters;

        if (Array.isArray(filters.name)) {
            if (filters.name.length > 0) {
                if (FilterGroup.smartSearch()) {
                    stringFilters += '&q.kind.eq=Coating&filter=' + filters.name.join(',');
                }
                else {
                    stringFilters += '&text=' + filters.name.join(',');
                }
            }
        }
        else if (filters.name) {
            if (FilterGroup.smartSearch()) {
                stringFilters += '&q.kind.eq=Coating&filter=' + filters.name
            }
            else {
                stringFilters += '&text=' + filters.name;
            }
        }

        stringFilters += '&sort=-isHpFloorGenerator,-created_at';

        this.filters.forEach((filter: IFilter) => {
            stringFilters += filter.generateStringFilter();
        });

        stringFilters += this.generateSortString();

        return stringFilters;
    };

    destroy(): void {
        super.destroy();
    }

}